import * as filesizeParser from 'filesize-parser';
import React from 'react';
import * as cookie from 'react-cookies';

import { Telemetry } from '@videoblocks/kafka-rest-client';

import { showPopUp } from '../../../../PopUps/actions/PopUpsActions';
import { CONFIRM_ACTION_MODAL } from '../../../../PopUps/components/types';
import { notify } from '../../../../ReactToastify/containers/ReactToastifyContainer';
import SiteConstants from '../../../../common/SiteConstants/SiteConstants';
import { getPreviewUrl } from '../../../../common/utils';

export const nonWaterMarkedBatchDownload = (selectedItems) => {
  selectedItems.forEach((binItem) => {
    let smallestFormatSize = Number.MAX_VALUE;
    let smallestFormatDownloadUrl = '';

    binItem.stockItemFormats.forEach((stockItemFormat) => {
      const fileSizeBytes = filesizeParser(stockItemFormat.filesize);

      if (fileSizeBytes < smallestFormatSize) {
        smallestFormatSize = fileSizeBytes;
        smallestFormatDownloadUrl = stockItemFormat.downloadUrl;
      }
    });

    if (smallestFormatDownloadUrl !== '') {
      window.open(smallestFormatDownloadUrl);
    }
  });
};

export const watermarkedBatchDownload = (selectedItems) => {
  selectedItems.forEach((binItem) => {
    window.open(
      getPreviewUrl(binItem.stockItem.id, binItem.stockItem.contentClass)
    );
  });
};

export const bulkDownloadUpgradeHookExperience = (uniqueId) => {
  window.location =
    SiteConstants.getInstance().getUpgradeMyPlanBasePath() + `/${uniqueId}`;
};

export const showSelectItemsModal = (dispatch) => {
  dispatch(
    showPopUp(CONFIRM_ACTION_MODAL, {
      title: 'Uh-Oh',
      message:
        'There are no items selected. Please select at least 1 item first before continuing',
      buttonText: 'Ok!',
    })
  );
};

export const shouldShowBatchDownloadingMessage = () => {
  let batchDownloadMessage = cookie.load('bdm');

  if (!batchDownloadMessage) {
    batchDownloadMessage = true;
    cookie.save('bdm', batchDownloadMessage, {
      path: '/',
      domain: '.' + window.location.hostname,
    });
    return true;
  }

  return false;
};

export const logStartOfBatchDownload = () => {
  Telemetry.increment('folders.batchDownload');
};

export const notifytUserToStartOfBatchDownload = (numberOfDownloadedItems) => {
  const itemText = numberOfDownloadedItems > 1 ? 'items' : 'item';
  const messageElement = (
    <>
      Downloading {numberOfDownloadedItems} {itemText} <br />{' '}
      <a
        href="https://help.storyblocks.com/en/articles/6001903-where-are-all-the-downloads-i-initiated-from-my-folder"
        className="underline ml-1 text-black font-bold"
        target="_blank"
      >
        Where are my downloads?
      </a>
    </>
  );
  notify(messageElement);
};

export const performBulkDownloadWithUIExperience = (
  dispatch,
  binName,
  selectedItems,
  downloadSelectedItems
) => {
  if (selectedItems.length === 0) {
    showSelectItemsModal(dispatch);
  } else {
    if (shouldShowBatchDownloadingMessage()) {
      dispatch(
        showPopUp(CONFIRM_ACTION_MODAL, {
          title: '',
          message:
            'You may have to allow pop-ups within your browser to enable batch downloading.',
          buttonText: 'OK',
          buttonAction: () => {
            logStartOfBatchDownload();
            downloadSelectedItems(selectedItems);
            notifytUserToStartOfBatchDownload(selectedItems.length);
          },
        })
      );
    } else {
      logStartOfBatchDownload();
      downloadSelectedItems(selectedItems);
      notifytUserToStartOfBatchDownload(selectedItems.length);
    }
  }
};
